import React, { useState } from "react";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import LabelAndInputNumber from "../common/form/labelAndInputNumber";
import LabelAndInputMask from "../common/form/labelAndInputMask";
import Select from "../common/form/select";
import FileChooser from "../common/form/fileChooser/fileChooser";

import LabelAndCheckbox from "../common/form/labelAndCheckbox";
import RadioButton from "../common/form/radioButton";
import { setError } from "../common/toast/toast";

const TIPOS_ANALISE = {
    SIMPLES: "simples",
    COMPARTILHADA: "compartilhada",
};

export function ContratoAluguelHistoricoForm(props) {
    if (!props.contrato) return null;

    const [tipoAnalise, setTipoAnalise] = useState(props.contrato.id_grupo_contrato_aluguel ? TIPOS_ANALISE.COMPARTILHADA : TIPOS_ANALISE.SIMPLES);

    const contratoPreenchido =
        props.contrato &&
        props.contrato.competencia_inicio_vigencia &&
        props.contrato.competencia_fim_vigencia &&
        props.contrato.valor_mensal_aluguel &&
        props.contrato.quantidade_energia_contratada_anual &&
        props.contrato.arquivo_contrato;

    return (
        <ContentCardBody style={{ border: "1px solid #dadada", marginBlock: 20, borderRadius: 10 }}>
            <Row>
                <LabelAndInputMask
                    name="competencia_inicio_vigencia"
                    label="Início da Vigência"
                    placeholder="MM/AAAA"
                    cols="12 12 2 2"
                    mask="99/9999"
                    readOnly={!!props.contrato.readOnly}
                    value={props.contrato.competencia_inicio_vigencia}
                    onChange={(e) => {
                        props.handleContratoForm({
                            competencia_inicio_vigencia: e.target.value,
                        });
                    }}
                />
                <LabelAndInputMask
                    name="competencia_fim_vigencia"
                    label="Fim da Vigência"
                    placeholder="MM/AAAA"
                    cols="12 12 2 2"
                    mask="99/9999"
                    readOnly={!!props.contrato.readOnly}
                    value={props.contrato.competencia_fim_vigencia}
                    onChange={(e) => {
                        props.handleContratoForm({
                            competencia_fim_vigencia: e.target.value,
                        });
                    }}
                />
                <LabelAndInputNumber
                    name="valor_mensal_aluguel"
                    label="Valor Mensal do Aluguel(R$)"
                    placeholder="0,00"
                    readOnly={!!props.contrato.readOnly}
                    cols="12 12 2 2"
                    casas={2}
                    value={props.contrato.valor_mensal_aluguel}
                    allowNegative={false}
                    onChange={(e) => {
                        props.handleContratoForm({
                            valor_mensal_aluguel: e.target.value,
                        });
                    }}
                />

                <LabelAndInputNumber
                    name="quantidade_energia_contratada_anual"
                    label="Qtd. de Energia Contratada Anual(kWh)"
                    placeholder="0,00"
                    readOnly={!!props.contrato.readOnly}
                    cols="12 12 3 3"
                    casas={2}
                    value={props.contrato.quantidade_energia_contratada_anual}
                    allowNegative={false}
                    onChange={(e) => {
                        props.handleContratoForm({
                            quantidade_energia_contratada_anual: e.target.value,
                        });
                    }}
                />

                <Grid cols="12 12 3 3" style={{ paddingLeft: 0, paddingRight: 6 }}>
                    {props.contrato.arquivo_contrato ? (
                        <div
                            className="d-flex"
                            style={{
                                margin: 15,
                                gap: 10,
                                padding: 10,
                                backgroundColor: "#f4f4f4",
                            }}
                        >
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ color: "#0040ff", border: "1px solid #0040ff", height: 40, width: 40, fontSize: "1.4rem" }}
                            >
                                <i className="fas fa-file" />
                            </div>
                            <Button
                                disabled={!!props.contrato.readOnly}
                                style={{ margin: 0 }}
                                text={"Remover Arquivo"}
                                type={"danger"}
                                icon={"fa fa-times"}
                                event={() => {
                                    props.handleContratoForm({
                                        arquivo_contrato: null,
                                    });
                                }}
                            />
                        </div>
                    ) : (
                        <FileChooser
                            solid={true}
                            style={{ margin: "0px 5px" }}
                            readOnly={!!props.contrato.readOnly}
                            nome=""
                            base64=""
                            label="Arquivo do Contrato"
                            onFileSelect={async (base64ComNomeJSON) => {
                                props.handleContratoForm({
                                    arquivo_contrato: base64ComNomeJSON.base64,
                                });
                            }}
                        />
                    )}
                </Grid>
            </Row>
            <Row>
                <LabelAndCheckbox
                    label="O locatário assume o custo da fatura da usina Fonte Geradora"
                    title={{
                        desmarcado: "O locatário NÃO assume o custo da fatura da usina Fonte Geradora",
                        marcado: "O locatário assume o custo da fatura da usina Fonte Geradora",
                    }}
                    cols="12 12 12 3"
                    readOnly={!!props.contrato.readOnly}
                    value={props.contrato.assume_custo_fatura_usina_geradora}
                    onChange={(e) => {
                        props.handleContratoForm({
                            assume_custo_fatura_usina_geradora: !props.contrato.assume_custo_fatura_usina_geradora,
                        });
                    }}
                />
            </Row>
            <Row>
                <Grid
                    cols="12 12 3 3"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        height: "min-content",
                        marginBottom: 20,
                    }}
                >
                    <RadioButton
                        nameField="Selecione o tipo de análise"
                        options={[
                            {
                                id: TIPOS_ANALISE.SIMPLES,
                                name: "tipo_analise",
                                value: TIPOS_ANALISE.SIMPLES,
                                conditionChecked: tipoAnalise === TIPOS_ANALISE.SIMPLES,
                                event: (e) => setTipoAnalise(e.target.value),
                                label: "Simples",
                            },
                            {
                                id: TIPOS_ANALISE.COMPARTILHADA,
                                name: "tipo_analise",
                                value: TIPOS_ANALISE.COMPARTILHADA,
                                conditionChecked: tipoAnalise === TIPOS_ANALISE.COMPARTILHADA,
                                event: (e) => setTipoAnalise(e.target.value),
                                label: "Compartilhada",
                            },
                        ]}
                        readOnly={!!props.contrato.readOnly}
                    />
                </Grid>
            </Row>

            {tipoAnalise === TIPOS_ANALISE.COMPARTILHADA && (
                <Row style={{ marginBottom: 20 }}>
                    <Select
                        name="id_grupo_contrato_aluguel"
                        options={props.listaGrupoContratoAluguel}
                        label="Grupo de Análise de Contrato de Aluguel"
                        cols={"12 12 4 4"}
                        placeholder="Selecione o Grupo de Análise"
                        value={props.contrato.id_grupo_contrato_aluguel}
                        isClearable={true}
                        isSearchable={false}
                        onChange={(value) => props.handleContratoForm({ id_grupo_contrato_aluguel: value })}
                    />
                    <Grid cols="12 12 3 3">
                        <Button
                            style={{ margin: "29px 0px 0px 0px" }}
                            text={"Cadastro de Grupo de Análise"}
                            type={"primary"}
                            icon={"fas fa-object-group"}
                            disabled={!!props.contrato.readOnly}
                            event={props.handleOpenModalGrupoContratoAluguelForm}
                        />
                    </Grid>
                </Row>
            )}
            <Row>
                <Grid
                    cols="12 12 6 6"
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        height: "min-content",
                        marginBottom: 20,
                    }}
                >
                    <RadioButton
                        nameField="Selecione o tipo de custo de gestão"
                        options={props.listaTipoCustoGestaoContratoAluguel.map((tipoCusto) => {
                            return {
                                id: `tipo_custo_gestao_${tipoCusto.id}`,
                                name: "id_tipo_custo_gestao_contrato_aluguel",
                                value: tipoCusto.id,
                                conditionChecked: props.contrato.id_tipo_custo_gestao_contrato_aluguel === tipoCusto.id,
                                event: (e) =>
                                    props.handleContratoForm({
                                        id_tipo_custo_gestao_contrato_aluguel: Number(e.target.value),
                                        valor_custo_gestao_contrato_aluguel: null,
                                        percentual_custo_gestao_contrato_aluguel: null,
                                    }),
                                label: tipoCusto.nome,
                                title: tipoCusto.descricao,
                            };
                        })}
                        readOnly={!!props.contrato.readOnly}
                    />
                </Grid>
            </Row>
            {[2, 3].includes(props.contrato.id_tipo_custo_gestao_contrato_aluguel) ? (
                <Row>
                    <LabelAndInputNumber
                        key={props.contrato.id_tipo_custo_gestao_contrato_aluguel}
                        name="valor_custo_gestao_contrato_aluguel"
                        label={props.contrato.id_tipo_custo_gestao_contrato_aluguel === 2 ? "Valor fixo mensal (R$)" : "Valor sobre o consumo (R$/kWh)"}
                        placeholder="0,00"
                        readOnly={!!props.contrato.readOnly}
                        cols="12 12 3 3"
                        casas={2}
                        value={props.contrato.valor_custo_gestao_contrato_aluguel}
                        allowNegative={false}
                        onChange={(e) => {
                            props.handleContratoForm({
                                valor_custo_gestao_contrato_aluguel: e.target.value,
                            });
                        }}
                    />
                </Row>
            ) : [4].includes(props.contrato.id_tipo_custo_gestao_contrato_aluguel) ? (
                <Row>
                    <LabelAndInputNumber
                        key={props.contrato.id_tipo_custo_gestao_contrato_aluguel}
                        name="percentual_custo_gestao_contrato_aluguel"
                        label="Percentual sobre o valor de economia da fatura (%)"
                        placeholder="0,00"
                        readOnly={!!props.contrato.readOnly}
                        cols="12 12 3 3"
                        casas={2}
                        value={props.contrato.percentual_custo_gestao_contrato_aluguel}
                        allowNegative={false}
                        onChange={(e) => {
                            props.handleContratoForm({
                                percentual_custo_gestao_contrato_aluguel: e.target.value,
                            });
                        }}
                    />
                </Row>
            ) : null}

            <Row alignCenter>
                {props.contrato.readOnly ? null : (
                    <Grid cols="12 12 4 3">
                        <Button
                            style={{ margin: 0 }}
                            text={"Salvar"}
                            type={"success"}
                            icon={"fa fa-check"}
                            solid={true}
                            disabled={!!props.contrato.readOnly || !contratoPreenchido}
                            event={() => {
                                if (tipoAnalise === TIPOS_ANALISE.COMPARTILHADA && !props.contrato.id_grupo_contrato_aluguel) {
                                    return setError("O tipo análise compartilhada exige que selecione um grupo de análise");
                                }
                                props.handleSubmitContrato();
                            }}
                        />
                    </Grid>
                )}
                {!!props.contrato && (
                    <Grid cols="12 12 4 3">
                        <Button
                            style={{ margin: 0 }}
                            text={"Cancelar"}
                            type={"danger"}
                            icon={"fa fa-times"}
                            solid={true}
                            event={() => {
                                props.handleCloseContratoForm();
                            }}
                        />
                    </Grid>
                )}
            </Row>
        </ContentCardBody>
    );
}
